import { _notNil } from '@/littledash.ts';
import { historyEventBus, HistoryPushEvent } from '@/utils/history.ts';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Bridge component that listens to custom history events and navigates
 * Converted from useHistory to useNavigate (React Router v6)
 */
export const BrowserHistoryEventBridge: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (_notNil(navigate)) {
      const abortController = new AbortController();
      historyEventBus.addEventListener(
        'history:push',
        (event) => {
          const path = (event as HistoryPushEvent)?.detail?.path;
          if (path) {
            navigate(path);
          }
        },
        { capture: true, signal: abortController.signal }
      );
      return () => {
        abortController.abort('destroy');
      };
    }
  }, [navigate]);

  return children;
};
